import React, { Component } from "react";
import { connect } from "react-redux";

import LocaleStrings from "@language";

// Import BaseLoader
import BaseLoader from "@baseLoader";

// Import Component
import AppSuggestionsEdit from "./appsuggestionsedit";

class AppSuggestions extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      loaderDesc: LocaleStrings.preparing_app_suggestions,
    };

    // All Binded Functions
  }

  componentDidMount() {
    this.setState({ loading: false });
  }

  componentWillUnmount() {
    this.setState({ loading: true });
  }

  render() {
    return (
      <>
        {this.props.user.isfreeze == false ? (
          <>
            {this.state.loading ? (
              <>
                <BaseLoader data={this.state.loaderDesc} />
              </>
            ) : (
              <AppSuggestionsEdit />
            )}
          </>
        ) : (
          <div className="flex items-center justify-center h-screen">
            <div className="text-center">{LocaleStrings.account_freezed}</div>
          </div>
        )}
      </>
    );
  }
}

var mapStateToProps = (state) => ({
  isLoggedIn: state.isLoggedIn,
  user: state.user,
  session: state.session,
});

export default connect(mapStateToProps, {})(AppSuggestions);
